import { ShieldAlert, Waves, ExternalLink } from "lucide-react";

export default function AccessDenied() {
  const adminUrl = "https://www.spincycles.in";

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col justify-center items-center px-4 py-12 relative overflow-hidden">
      {/* Background ambient glow */}
      <div className="absolute w-[500px] h-[500px] rounded-full bg-emerald-500/10 blur-[120px] pointer-events-none -top-40 -left-40" />
      <div className="absolute w-[400px] h-[400px] rounded-full bg-blue-500/10 blur-[100px] pointer-events-none -bottom-20 -right-20" />

      <div className="w-full max-w-md bg-slate-800/80 backdrop-blur-xl border border-slate-700/60 rounded-2xl p-8 shadow-2xl relative z-10 text-center">
        {/* Brand header */}
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center shadow-lg shadow-primary/30">
            <Waves className="w-5 h-5 text-white" />
          </div>
          <div className="text-left">
            <div className="text-white font-bold text-sm tracking-tight">Control Tower</div>
            <div className="text-slate-400 text-[10px] uppercase tracking-wider">Laundry Intelligence</div>
          </div>
        </div>

        {/* Shield icon */}
        <div className="w-16 h-16 rounded-2xl bg-rose-500/15 border border-rose-500/30 flex items-center justify-center mx-auto mb-6 text-rose-400">
          <ShieldAlert className="w-8 h-8" />
        </div>

        <h1 className="text-2xl font-bold text-white tracking-tight mb-2">Access Denied</h1>
        <p className="text-slate-400 text-sm leading-relaxed mb-6">
          This Control Tower portal is accessible only through your authorized <span className="text-slate-300 font-medium">Admin Web App</span>. Direct credentials login is disabled.
        </p>

        <div className="bg-slate-900/60 rounded-xl border border-slate-700/50 p-4 mb-6 text-left">
          <div className="text-xs font-semibold text-slate-300 mb-1">How to access:</div>
          <div className="text-xs text-slate-400 leading-normal">
            Please log in to your main SpinCycles Admin Portal and click the Control Tower link to automatically establish your secure session.
          </div>
        </div>

        {/* <a
          href={adminUrl}
          className="inline-flex items-center justify-center gap-2 w-full h-11 px-5 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary/90 transition shadow-lg shadow-primary/25"
        >
          <span>Return to Admin Portal</span>
          <ExternalLink className="w-4 h-4" />
        </a> */}
      </div>

      <div className="mt-8 text-xs text-slate-500">
        SpinCycles
      </div>
    </div>
  );
}
